
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import CveTitle from '../../components/cveTitle.js'
import Pagination from '../../components/pagination.js'
import CVEList from '../../components/cveList.js'
import {RtPage} from '../../../../server/routes/route-types.js'

import {RtCVEInfo, RtAllCVEsPageResult} from '../../../../server/routes/cve.js'

interface CVEAllProps {
	server: string;
	pageData: unknown;
}

export default function CVEAll({server, pageData}: CVEAllProps) {

	let [data, setData] = useState(pageData as RtAllCVEsPageResult);
	
	const title = 'CVEs';
	const subtitle = 'List of Common Vulnerabilities and Exposures (CVEs) and affected websites count. Only CVEs that are detectable from client-side software packages and libraries are included.';

	return (
	<>
		<section className="section section-sm">
			<div className="container">
				<div className="row row-50">
					<div className="col-md-12 col-lg-12 col-xl-12">
						<CVEList data ={data} list={data.CVEs} title={title} subtitle={subtitle}/>
					</div>					
				</div>
			</div>
		</section>
	</>
	)
}

